import React, { useState } from "react";
import { PrimarySimpleDropdown } from "../../dropdowns/simple-dropdown";

export default function CampaignChannelDropdown({ defaultValue = "email", handleSelect }) {
  const [channelDropdownValue, setChannelDropdownValue] = useState(defaultValue);
  return (
    <PrimarySimpleDropdown
      value={channelDropdownValue}
      label={channelDropdownValue}
      handleSelect={(selected) => {
        setChannelDropdownValue(selected);
        handleSelect(selected);
      }}
      options={[
        { label: "SMS", value: "sms" },
        { label: "Email", value: "email" },
        { label: "Email Validation", value: "email_validation" },
        { label: "Email Finder", value: "email_finder" },
        { label: "Whatsapp (Cloud API)", value: "whatsapp" },
        { label: "Whatsapp (Channel Partner)", value: "whatsapp2" },
        { label: "Google RCS", value: "rcs" },
      ]}
    />
  );
}
